/* eslint-disable no-use-before-define */
// import 'event-source-polyfill';
import moment from 'moment';

import Vue from 'vue';
import VueI18n from 'vue-i18n';

import SocialSharing from 'vue-social-sharing';

import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFacebookSquare, faVk, faOdnoklassniki } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope, faHeart, faClipboard } from '@fortawesome/free-regular-svg-icons';
import VueClipboard from 'vue-clipboard2';
import VueGtag from 'vue-gtag';
import vuetify from './plugins/vuetify';

// import { mapState } from 'vuex';
import App from './App.vue';
import router from './router';
import store from './store/store';

import messages from './messages';

if (process.env.NODE_ENV !== 'development') {
  Vue.use(VueGtag, {
    appName: 'КНИГИ В ГОРОДЕ.Тобольск 24 -26.05.2024',
    config: { id: 'G-VSNF97NPHX' },
  }, router);
}

// eslint-disable-next-line import/no-dynamic-require
Vue.prototype.$appLogo = require(process.env.VUE_APP_LOGO || '@/assets/logo.png');

Vue.prototype.$getAssets = (path) => {
  const src = require.context('@/assets/', false);
  return src(`./${path}`);
};

Vue.prototype.$theme = {
  color: 'black',
  background: '#FFF',
};

Vue.use(VueClipboard);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'ru', // set locale
  messages, // set locale messages
});

Vue.config.productionTip = false;

Vue.component('font-awesome-icon', FontAwesomeIcon);
library.add(faFacebookSquare, faVk, faOdnoklassniki, faEnvelope, faHeart, faClipboard, faLink);

/**
Vue.use(Vuetify, {
  iconfont: 'md',
});
* */

Vue.use(SocialSharing);

const regexToRGB3 = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})$/i;
const regexToRGB6 = /^#?([a-f\d]{1,2})([a-f\d]{1,2})([a-f\d]{1,2})$/i;

Vue.prototype.getAbsoluteHeight = (el) => {
  // Get the DOM Node if you pass in a string
  const $el = (typeof el === 'string') ? document.querySelector(el) : el;
  let res = 0;

  if ($el instanceof Element || $el instanceof Document) {
    const styles = window.getComputedStyle($el);
    const margin = parseFloat(styles.marginTop)
                + parseFloat(styles.marginBottom);

    res = Math.ceil($el.offsetHeight + margin);
  }

  return res;
};

Vue.prototype.wc_hex_is_light = (color) => {
  const hex = color.replace('#', '');
  const cR = parseInt(hex.substr(0, 2), 16);
  const cG = parseInt(hex.substr(2, 2), 16);
  const cB = parseInt(hex.substr(4, 2), 16);
  const brightness = ((cR * 299) + (cG * 587) + (cB * 114)) / 1000;
  return brightness > 155;
};

Vue.prototype.getEventColor = (event, key) => {
  let bColor = '#aaaaaa';
  try {
    bColor = event.colors[key] || '#aaaaaa';
  } catch (e) {
  }
  return {
    color: bColor,
    text: Vue.prototype.wc_hex_is_light(bColor) ? '#000000' : '#ffffff',
  };
};

Vue.prototype.toRGB = (color, opacity = 1) => {
  // eslint-disable-next-line no-nested-ternary
  const result = color.length === 4
    ? regexToRGB3.exec(color)
    : (color.length === 7
      ? regexToRGB6.exec(color)
      : null);

  const res = result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16),
    a: opacity,
  } : null;

  return `rgba(${res.r}, ${res.g}, ${res.b}, ${res.a})`;
};
window.toRGB = Vue.prototype.toRGB;

Vue.prototype.$getLocation = () => {
  let url = window.location.toString();

  if (app.$route.name === 'event') {
    // eslint-disable-next-line prefer-destructuring
    url = url.split('?')[0];
  }
  return url;
};

// http://master.virmandy.net/dvustoronniy-translit-na-js/
// https://habrahabr.ru/post/127943/
// eslint-disable-next-line no-array-constructor
const arrru = new Array('Я', 'я', 'Ю', 'ю', 'Ч', 'ч', 'Ш', 'ш', 'Щ', 'щ', 'Ж', 'ж', 'А', 'а', 'Б', 'б', 'В', 'в', 'В', 'в', 'Г', 'г', 'Д', 'д', 'Е', 'е', 'Ё', 'ё', 'З', 'з', 'И', 'и', 'Й', 'й', 'К', 'к', 'Л', 'л', 'М', 'м', 'Н', 'н', 'О', 'о', 'П', 'п', 'Р', 'р', 'С', 'с', 'Т', 'т', 'У', 'у', 'Ф', 'ф', 'Х', 'х', 'Ц', 'ц', 'Ы', 'ы', 'Ь', 'ь', 'Ъ', 'ъ', 'Э', 'э');
// eslint-disable-next-line no-array-constructor
const arren = new Array('Ya', 'ya', 'Yu', 'yu', 'Ch', 'ch', 'Sh', 'sh', 'Sh', 'sh', 'Zh', 'zh', 'A', 'a', 'B', 'b', 'V', 'v', 'W', 'w', 'G', 'g', 'D', 'd', 'E', 'e', 'E', 'e', 'Z', 'z', 'I', 'i', 'J', 'j', 'K', 'k', 'L', 'l', 'M', 'm', 'N', 'n', 'O', 'o', 'P', 'p', 'R', 'r', 'S', 's', 'T', 't', 'U', 'u', 'F', 'f', 'H', 'h', 'C', 'c', 'Y', 'y', '`', '`', '\'', '\'', 'E', 'e');

Vue.prototype.$cyrill_to_latin = (text) => {
  let tmp = text;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < arrru.length; i++) {
    const reg = new RegExp(arrru[i], 'g');
    tmp = tmp.replace(reg, arren[i]);
  } //
  return tmp;
};

Vue.prototype.$latin_to_cyrill = (text) => {
  let tmp = text;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < arren.length; i++) {
    const reg = new RegExp(arren[i], 'g');
    tmp = tmp.replace(reg, arrru[i]);
  }
  return tmp;
};

// Add moment filter
window.moment = moment;
Vue.prototype.$moment = moment;
Vue.filter('moment', (input, format, delimiter = '–', utc = '+0500') => {
  let dates = Array.isArray(input) ? input : [input];
  if (!input) dates = [];
  const result = dates
    .filter((date) => date || false)
    .map((date) => {
      const tmp = moment(date).utcOffset(utc);
      return tmp.isValid() ? tmp.format(format) : ' ';
    })
    .join(delimiter);
  return result;
});

const app = new Vue({
  i18n,
  router,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount('#app');
